import React from "react";
import LegalLayout from "./LegalLayout";

const HowToHire = () => (
  <LegalLayout title="Cómo contratar nuestros servicios">
    <p>VPEX ofrece desarrollo de aplicaciones y sitios web, implementación de infraestructura tecnológica, soporte y productos digitales para empresas. Los proyectos a medida se contratan mediante una propuesta personalizada.</p>
    <h2>Proceso de contratación</h2>
    <ol>
      <li>El cliente se comunica mediante el formulario, correo electrónico o WhatsApp y describe su necesidad.</li>
      <li>VPEX analiza el requerimiento y, cuando corresponde, coordina una reunión de relevamiento.</li>
      <li>Se envía una propuesta con alcance, entregables, precio, forma de pago, plazo estimado y condiciones particulares.</li>
      <li>El servicio queda contratado cuando el cliente acepta expresamente la propuesta y realiza el pago o anticipo indicado.</li>
      <li>VPEX inicia el trabajo cuando dispone de la información, accesos y materiales necesarios.</li>
      <li>Las revisiones, pruebas, entrega, publicación y soporte posterior se realizan según lo establecido en la propuesta aceptada.</li>
    </ol>
    <h2>Servicios personalizados</h2>
    <p>El precio y el plazo de los desarrollos, configuraciones e implementaciones dependen de su alcance. Toda funcionalidad, tarea o cambio no incluido inicialmente puede requerir una nueva estimación y aprobación.</p>
    <h2>Productos y servicios recurrentes</h2>
    <p>Cuando se contrata una licencia, suscripción o soporte recurrente, la periodicidad, el precio, las funcionalidades incluidas y las condiciones de cancelación se informan antes del pago.</p>
    <h2>Contacto comercial</h2>
    <p>Correo: <a href="mailto:valvarez@vpex.com.uy">valvarez@vpex.com.uy</a><br />WhatsApp y teléfono: <a href="tel:+59899447449">+598 99 447 449</a></p>
  </LegalLayout>
);
export default HowToHire;
